import lazyLoad from 'Components/asyncLoading/lazyLoad';

export default lazyLoad({
    loader: () => import(
        /* webpackChunkName: "image-gallery-dots" */
        'react-carousel-dots'
    )
});
